<template>
    <q-dialog v-model="showInformativeDialog" persistent>
        <q-card>
            <q-card-section class="row items-center">
                <span class="q-ml-sm">{{ message }}</span>
            </q-card-section>

            <q-card-actions align="center">
                <q-btn flat label="Aceptar" color="primary" v-close-popup/>
            </q-card-actions>
        </q-card>
    </q-dialog>
</template>

 
<script lang="ts">
import { computed, defineComponent } from 'vue';

interface Props {
    toggleInformativeModal?: boolean;
    message?: string;
}

export default defineComponent({
    name: 'InformativeModalComponent',
    props: {
        toggleInformativeModal: { type: Boolean },
        message: { type: String },
    },
    emits: ['update:toggleConfirmModal'],
    setup(props: Props, { emit }) {
        
        const showInformativeDialog = computed({
            get() { return props.toggleInformativeModal },
            set(newValue) { emit('update:toggleConfirmModal', newValue) }
        });

        return {
            showInformativeDialog,
        }
    }
});
</script>